import classnames from "classnames";

type Size = "large" | "normal" | "medium" | "small";

export interface CommonProps {
  size?: Size | { mobile: Size; tablet: Size };
  kind: "primary" | "secondary" | "text" | "link";
  iconLeft?: (props: React.SVGProps<SVGSVGElement>) => JSX.Element;
  iconRight?: (props: React.SVGProps<SVGSVGElement>) => JSX.Element;
  disabled?: boolean;
  classNameOverride?: Record<string, string>;
}

function getSizeClasses(size: Size, tablet: boolean) {
  let iconClass = "";
  let sizeClass = "";
  switch (size) {
    case "large":
      sizeClass = tablet
        ? "tablet:txt-btn-lg tablet:px-8 tablet:py-5 tablet:space-x-3.5"
        : "txt-btn-lg px-8 py-5 space-x-3.5";
      iconClass = tablet ? "tablet:w-6 tablet:h-6" : "w-6 h-6";
      break;
    case "normal":
      sizeClass = tablet
        ? "tablet:txt-btn tablet:px-8 tablet:py-4 tablet:space-x-3.5"
        : "txt-btn px-8 py-4 space-x-3.5";
      iconClass = tablet ? "tablet:w-6 tablet:h-6" : "w-6 h-6";
      break;
    case "medium":
      sizeClass = tablet
        ? "tablet:txt-btn-md tablet:px-8 tablet:py-3.5 tablet:space-x-2.5"
        : "txt-btn-md px-8 py-3.5 space-x-2.5";
      iconClass = tablet ? "tablet:w-5 tablet:h-5" : "w-5 h-5";
      break;
    case "small":
      sizeClass = tablet
        ? "tablet:txt-btn-sm tablet:px-6 tablet:py-3 tablet:space-x-2"
        : "txt-btn-sm px-6 py-3 space-x-2";
      iconClass = tablet ? "tablet:w-4 tablet:h-4" : "w-4 h-4";
      break;
  }
  return { iconClass, sizeClass };
}

export function getClasses(size: CommonProps["size"], kind: CommonProps["kind"], disabled?: boolean) {
  let iconClass = "align-middle inline";
  let sizeClass = "";
  if (!size || typeof size === "string") {
    const { iconClass: i, sizeClass: s } = getSizeClasses(size || "large", false);
    iconClass = classnames(iconClass, i);
    sizeClass = classnames(sizeClass, s);
  } else {
    const { iconClass: im, sizeClass: sm } = getSizeClasses(size.mobile, false);
    const { iconClass: it, sizeClass: st } = getSizeClasses(size.tablet, true);
    iconClass = classnames(iconClass, im, it);
    sizeClass = classnames(sizeClass, sm, st);
  }
  let kindClass = classnames(
    "inline-block",
    "text-center",
    "rounded",
    "ring-inset",
    "focus:ring-2",
    "focus:ring-info",
    {
      "bg-button-disabled": disabled,
      "text-button-disabled-text": disabled,
      "cursor-not-allowed": disabled,
      "ring-0": disabled,
      "cursor-pointer": !disabled,
    }
  );
  if (!disabled) {
    switch (kind) {
      case "primary":
        kindClass = classnames(
          kindClass,
          "focus:bg-button-primary-focused",
          "active:bg-button-primary-active",
          "hover:bg-button-primary-hover",
          "bg-button-primary",
          "text-button-primary-text"
        );
        break;
      case "secondary":
        kindClass = classnames(
          kindClass,
          "focus:bg-button-secondary-focused",
          "active:bg-button-secondary-active",
          "hover:bg-button-secondary-hover",
          "ring-1",
          "ring-body",
          "bg-button-secondary",
          "text-button-secondary-text"
        );
        break;
      case "text":
        kindClass = classnames(
          kindClass,
          "focus:bg-button-secondary-focused",
          "active:bg-button-secondary-active",
          "hover:bg-button-secondary-hover",
          "bg-button-secondary",
          "text-button-secondary-text"
        );
        break;
    }
  }
  return { sizeClass, iconClass, kindClass };
}
